var axios = require("axios");
// const coupon_url = 'http://localhost:8000/' + process.env.version + '/product-coupon-be'
const coupon_url = process.env.prefix_coupon
const game_url = `/${process.env.version_v4}/${process.env.prefix_gamification}/rules`
const history_url = `/${process.env.version_v4}/${process.env.prefix_gamification}/grant-token-log`
const download_history_url = `${history_url}/download`

// get list outlets
axios.getOutlets = function (params, success, callBackError){
  this.get(process.env.prefix_outlet_fe+'/outlets/list?'+params)
  .then(response => {
    success(response);
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

// get list users
axios.getCouponCustomers = function (success, callBackError){
  this.get(process.env.prefix_customer+'/customers_for_coupons')
  .then(response => {
    success(response);
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

//coupon
axios.getGameCouponList = function (params, success, callBackError){
  this.get(coupon_url+'/coupons-game-list?'+params)
  .then(response => {
    success(response);
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.getCouponList = function (params, success, callBackError){
  this.get(coupon_url+'/coupons?'+params)
  .then(response => {
    success(response);
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.getExternalCouponList = function (params, success, callBackError){
  this.get(coupon_url+'/coupons?'+params)
  .then(response => {
    success(response);
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.getCouponTypies = function (success, callBackError){
  this.get(coupon_url+'/coupon-types')
  .then(response => {
    success(response);
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.updateCouponStatus = function (params, success, callBackError){
  let uuid = params['uuid']
  delete params['uuid']
  let active = params
  this.put(coupon_url+'/coupon/'+uuid, active)
  .then(response => {
    success(response);
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.getListMenu = function(param, success, callBackError){
  this.get(process.env.prefix_menu+'/menu-detail?limit='+param)
  .then(response => {
    success(response);
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.checkCode = function(code){
  return this.get(coupon_url+'/coupon/code-unique/'+code)
}

axios.getMenuById = function (params, success, callBackError){
  this.get(process.env.prefix_menu+'/menu/'+params)
  .then(response => {
    success(response);
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.createCoupon = function (params, success, callBackError){
  this.post(coupon_url+'/coupon', params)
  .then(response => {
    success(response);
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.updateCoupon = function (params, success, callBackError){
  this.put(coupon_url+'/coupon', params)
  .then(response => {
    success(response);
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.getCouponDetail = function (params, success, callBackError){
  this.get(coupon_url+'/coupon/'+params)
  .then(response => {
    success(response);
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.uploadCouponImages = function (params, configs, success, callBackError){
  this.post(coupon_url+'/coupon/upload-image', params, configs)
  .then(response => {
    success(response);
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.publishCoupon = function (success, callBackError){
  this.post(coupon_url+'/coupon-publish')
      .then(response => {
          success(response);
      }).catch(error => {
      if (error.response && error.response.status == 400) {
          if (typeof callBackError !== 'undefined') {
              callBackError(error.response.data)
          }
      }
  })
}

axios.getListCouponMenu = function(params, success, callBackError){
  this.get(process.env.prefix_menu+'/products'+params)
  .then(response => {
    success(response);
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.getListOutletGroup = function(params, success, callBackError){
  this.get(process.env.prefix_outlet+'/outlet-groups?'+params)
  .then(response => {
    success(response);
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.validateUserList = function (data, configs, success, callBackError) {
  this.post(process.env.prefix_customer + '/customers/validate', data, configs)
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status === 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.validateOutletList = function (data, configs, success, callBackError) {
  this.post(process.env.prefix_outlet + '/outlets/check-outlets', data, configs)
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status === 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.getExampleFile = function (success, callBackError) {
  this.get(coupon_url+'/example-file')
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status === 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.removeCsvFile = function (params, success, callBackError) {
  this.post(coupon_url+'/remove-csv-file', params)
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status === 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.getPaymentMethods = function (params, success, callBackError){
  this.get(process.env.prefix_payment+'/payment-methods'+params)
  .then(response => {
    success(response);
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

// GAMES
axios.updateGameStatus = function (params, success, callBackError){
  let uuid = params['uuid']
  delete params['uuid']
  let active = params
  this.put(coupon_url+'/game/'+uuid, active)
      .then(response => {
        success(response);
      }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.getGameList = function (params, success, callBackError){
  this.get(coupon_url+'/games?'+params)
  .then(response => {
    success(response);
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.uploadGameImages = function (params, configs, success, callBackError){
  this.post(coupon_url+'/game/upload-image', params, configs)
  .then(response => {
    success(response);
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.getGameDetail = function (params, success, callBackError){
  this.get(coupon_url+'/game/'+params)
  .then(response => {
    success(response);
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.createGame = function (params, success, callBackError){
  this.post(coupon_url+'/game', params)
  .then(response => {
    success(response);
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.updateGame = function (params, success, callBackError){
  this.put(coupon_url+'/game', params)
  .then(response => {
    success(response);
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.getToppings = function (params, success, callBackError){
  this.get(process.env.prefix_menu+'/toppings'+params)
  .then(response => {
    success(response);
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.getCouponMaster = function (params, success, callBackError){
  this.get(coupon_url+'/coupon-master'+params)
  .then(response => {
    success(response);
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.getCouponParent = function (params, success, callBackError){
  this.get(coupon_url+'/coupon-parent'+params)
  .then(response => {
    success(response);
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.createExternalCoupon = function (params, success, callBackError){
  this.post(
    coupon_url+'/external-coupon',
    params,
    {
      headers: {
        'Content-Type': `'multipart/form-data; boundary=${params._boundary}`
      }
    }
  )
  .then(response => {
    success(response);
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.updateExternalCoupon = function (params, success, callBackError){
  this.put(coupon_url+'/external-coupon', params)
  .then(response => {
    success(response);
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.getExternalCouponDetail = function (params, success, callBackError){
  this.get(coupon_url+'/external-coupon/'+params)
  .then(response => {
    success(response);
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.updateExternalCouponStatus = function (params, success, callBackError){
  let uuid = params['uuid']
  delete params['uuid']
  let active = params
  this.put(coupon_url+'/external-coupon/'+uuid, active)
  .then(response => {
    success(response);
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.getListAssignCoupon = function (params, success, callBackError){
  this.get(coupon_url+'/external-coupon-for-customer' + params)
  .then(response => {
    success(response);
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.assignCoupon = function (params, success, callBackError){
  this.post(coupon_url+'/assign-coupon', params)
  .then(response => {
    success(response);
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.exportCSVExternalCoupon = function (params, success, callBackError){
  this.get(coupon_url+'/exportCouponExternal?'+params)
    .then(response => {
      success(response);
    }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.getImportHistories = function (params, success, callBackError){
  this.get(coupon_url+'/import-histories?'+params)
  .then(response => {
    success(response);
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.downloadMissedCodesFile = function (uuid) {
  this.get(`${coupon_url}/download-missed-codes-file?uuid=${uuid}`).then((response) => {
     const url = window.URL.createObjectURL(new Blob([response.data]));
     const link = document.createElement('a');
     link.href = url
     link.setAttribute('download', `error-${uuid}.csv`); 
     document.body.appendChild(link);
     link.click();
  });
}

axios.getAllParentCoupons = function (success, callBackError) {
  this.get(`${coupon_url}/all-coupons`).then(response => {
    success(response);
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  });
}

axios.getAllCouponTypes = function (success, callBackError) {
  this.get(`${coupon_url}/coupon-types`).then(response => {
    success(response);
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  });
}

axios.syncCoupon = function (uuid, params, success, callBackError){
  this.put(`${coupon_url}/sync-coupon/${uuid}`, params)
  .then(response => {
    success(response);
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.getGameRuleList = function (success, callBackError){
  this.get(process.env.host + game_url)
  .then(response => {
    success(response);
  }).catch(error => {
    if (typeof callBackError !== 'undefined') {
      callBackError(error.response.data)
    }
  })
}

axios.editGameRuleList = function (email, params, success, callBackError){
  axios.defaults.headers.common['x-user-email'] = email
  this.post(process.env.host + game_url, params)
  .then(response => {
    success(response);
  }).catch(error => {
    if (typeof callBackError !== 'undefined') {
      callBackError(error.response.data)
    }
  })
}

axios.getGrantTokenHistory = function(success, callBackError) {
  this.get(process.env.host + history_url)
    .then(response => {
      success(response);
    })
    .catch(error => {
      if (typeof callBackError !== "undefined") {
        callBackError(error.response.data);
      }
    });
};

axios.getSignedUrl = function(s3_path, success, callBackError) {
  this.get(process.env.host + download_history_url, {
    params: {
      s3_path
    }
  })
    .then(response => {
      success(response);
    })
    .catch(error => {
      if (typeof callBackError !== "undefined") {
        callBackError(error.response.data);
      }
    });
};

export default axios;



// WEBPACK FOOTER //
// ./src/assets/api/Coupon.js